angular.module('env.data.repos.orders', [])

    .service("ordersRepository", function ($q, rest) {
        var _this = this;
        var orderType = "OrderModel";
        var orderTypeLite = "OrderModelLite";
        var orderItemType = "OrderItemModel";
        var documentType = "DocumentModel";
        var commentType = "CommentModel";
        var orderDef = rest.getDefinition(orderType);

        //region Orders

        /**
         * Get orders
         * @returns {!Promise.<RepresentationModel[]>} promise of orders collection
         */
        _this.getOrders = function () {
            return rest.map(orderDef).willReturn(orderType).get();
        };

        /**
         * Get orders by step code
         * @param {string} stepCode step code
         * @returns {!Promise.<RepresentationModel[]>} promise of orders collection
         */
        _this.getOrdersByStep = function (stepCode) {
            return rest.map(orderDef).willReturn(orderType).get({params: {stepCode: stepCode}});
        };

        /**
         * Get order by id
         * @param {string|number} id is of the Order
         * @returns {!Promise.<RepresentationModel>} promise of order
         */
        _this.getOrder = function (id) {
            return rest.map(orderDef).map(id).willReturn(orderType, id).get();
        };

        /**
         * Save order
         * @param {RepresentationModel} order Order Model
         * @returns {!Promise.<RepresentationModel>} promise of saved order
         */
        _this.saveOrder = function (order) {
            return rest.map(orderDef).save(order);
        };

        /**
         * Create order
         * @param {RepresentationModel} order Order Model
         * @returns {!Promise.<RepresentationModel>} promise of saved order
         */
        _this.createOrder = function (newOrder) {
            return rest.map(orderDef).post(newOrder);
        };

        //endregion

        //region Search

        var searchQueryCache = [];
        /**
         * Search orders
         * @param {{where: string, orderBy: string, pageNumber: number, rowsPerPage: number}} query
         * @returns {!Promise} promise of search results
         */
        _this.search = function (query, returnLiteModels) {
            var executing = _.find(searchQueryCache, function (q) {
                return _.isEqual(q.query, query);
            });
            if (executing) {
                return executing.promise
                    .then(function (resp) {
                        return _.clone(resp); // clone to prevent modification of response content
                    });
            }

            var p = rest
                .map(orderDef)
                .map("search")
                .willReturn(returnLiteModels ? orderTypeLite : orderType)
                .search(query)
                .then(function (resp) {
                    searchQueryCache = _.reject(searchQueryCache, function (q) {
                        return _.isEqual(q.query, query);
                    });
                    return _.clone(resp);
                }, function (err) {
                    searchQueryCache = _.reject(searchQueryCache, function (q) {
                        return _.isEqual(q.query, query);
                    });
                    return $q.reject(err);
                });

            searchQueryCache.push({
                query: _.clone(query),
                promise: $q.when(p)
            });

            return $q.when(p);
        };

        //endregion

        //region OrderItems

        /**
         * Get Order Items of the Order
         * @param {RepresentationModel|string} order Order Model or Order id
         * @returns {!Promise.<RepresentationModel[]>} promise of order items collection
         */
        _this.getOrderItemsForOrder = function (order) {
            return rest.map(orderDef).map(order).map("orderitems").willReturn(orderItemType).get();
        };

        //endregion

        //region Documents

        /**
         * Get Documents of the Order
         * @param {RepresentationModel|string} order Order Model or Order id
         * @returns {!Promise.<RepresentationModel[]>} promise of Documents collection
         */
        _this.getDocuments = function (order) {
            return rest.map(orderDef).map(order).map("documents").willReturn(documentType).get();
        };

        //endregion

        //region Comments of Order

        /**
         * Get Comments of the Order
         * @param {RepresentationModel|string} order Order Model or Order Id
         * @returns {!Promise.<RepresentationModel[]>} promise of Comments collection
         */
        _this.getComments = function (order) {
            return rest.map(orderDef).map(order).map("comments").willReturn(commentType).get();
        };

        /**
         * Save new comment of the Order
         * @param {RepresentationModel|string} order Order Model or Order Id
         * @param {RepresentationModel} comment Comment model
         * @returns {!Promise.<RepresentationModel>} promise of Comment save
         */
        _this.saveComment = function (order, comment) {
            return rest.map(orderDef).map(order).map("comments").post(comment);
        };

        //endregion

        //region Custom fields

        var _cfDefs;
        /**
         * Get all custom fields for Order
         * @returns {!Promise.<Object[]>} promise of Custom Field Definition list
         */
        _this.getCustomFieldDefinitions = function () {
            if (_cfDefs) {
                return $q.when(_.clone(_cfDefs));
            }
            return rest
                .map(orderDef)
                .map("customfielddefinitions")
                .get()
                .then(function (definitions) {
                    _cfDefs = definitions;
                    return _.clone(_cfDefs);
                });
        };

        //endregion

        return _this;
    })

    .run(function (rest, requestCoupler, requestCouplerUtils) {
        var baserUrl = om.config.build.baseUrl;
        var orderUrl = rest.getDefinition("OrderModel").getUrl();

        requestCoupler.addCoupler(requestCouplerUtils.createSimpleGetCollectionCoupler(orderUrl, baserUrl + "/" + orderUrl));
        requestCoupler.addCoupler(requestCouplerUtils.createCustomFieldsCollectionCoupler(orderUrl, "customfields", baserUrl + "/" + orderUrl + "/customfields"));
    })

;
